const LOADER_TYPES = {
    FULLSCREEN: 'FULLSCREEN',
    FULLSCREEN_TRANSPARENT: 'FULLSCREEN_TRANSPARENT',
    FULLSCREEN_FOR_SKELETON: 'FULLSCREEN_FOR_SKELETON',
};

export default LOADER_TYPES;
